import React, { PureComponent } from "react";
import classnames from "classnames";
import _ from "i18n";

import { TTP_API_URL, DAYS_CONFIG, ACTIVITIES_ACTIONS } from "Config";
import { getUserNameForAvatar } from "Utils";
import { TiArrowSortedDown, TiWarningOutline } from "react-icons/ti";

import { HistoryIcon } from "../Common/Icons";
import styles from "./CollaboratorSpace.local.scss";
import collaboratorApi from "../../services/CollaboratorServices";
import moment from "moment";
import CollaboratorSpaceAsideFetching from "./CollaboratorSpaceAsideFetching";
class CollaboratorSpaceAside extends PureComponent {
  //******************   Content Functions  **************//

  intervalID;

  constructor(props) {
    super(props);

    this.state = {
      wip: true,
      loading: false,
      error: false,
      activities: [],
      displayedActivities: [],
      day: DAYS_CONFIG[3],
      activitiesActions: ACTIVITIES_ACTIONS
    };
  }

  componentDidMount() {
    const { user, organization } = this.props;
    const { day } = this.state;
    this.setState({ loading: true });

    document.addEventListener(
      "mousedown",
      this.handleClickOutsideActivitiesFilter.bind(this)
    );

    collaboratorApi
      .fetchTaskByCollaborator(user.id, organization.uen)
      .then(response => {
        this.setState({
          activities: response.data.data,
          loading: false
        });
        this.handleSelectActivitiesFilter(day);
      })
      .catch(error => {
        this.setState({ error: true, loading: false });
      });
  }

  setActivitiesWrapperRef = node => {
    this.activitiesWrapperRef = node;
  };

  renderUserSection = () => {
    let { user } = this.props;
    let avatarDiv = null;

    if (user.avatarUrl) {
      avatarDiv = (
        <div
          id={`avatar-${user.id}`}
          className={classnames(styles.user_avatar, "employee")}
          style={{ backgroundImage: `url(${user.avatarUrl})` }}
        />
      );
    } else if (user.avatar) {
      avatarDiv = (
        <div
          id={`avatar-${user.id}`}
          className={classnames(styles.user_avatar, "employee")}
          style={{ backgroundImage: `url(${TTP_API_URL}/${user.avatar})` }}
        />
      );
    } else {
      avatarDiv = (
        <div
          id={`avatar-${user.id}`}
          className={classnames(styles.user_avatar, "empty-avatar", "employee")}
        >
          <span className="empty-avatar__initials">
            {getUserNameForAvatar(user.firstName, user.lastName)}
          </span>
        </div>
      );
    }

    let signatureDiv = [];
    signatureDiv.push(<h3 key="h3">{user.firstName + " " + user.lastName}</h3>);
    signatureDiv.push(
      <h4 key="h4">
        <span>
          {user.role && user.role.id !== undefined ? _(user.role.type) : ""}
        </span>
      </h4>
    );
    // eslint-disable-next-line
    signatureDiv.push(<h4 key="h5" />);

    return (
      <div className={styles.user}>
        <div className={styles.user_container}>{signatureDiv}</div>
        {avatarDiv}
      </div>
    );
  };

  renderActivityAction = $activity => {
    let { activitiesActions } = this.state;
    return <div className={styles.title}>{activitiesActions[$activity]}</div>;
  };

  renderActivitiesSection = () => {
    let { language } = this.props;
    let {
      activitiesFilterIsVisible,
      displayedActivities,
      loading,
      error,
      day
    } = this.state;
    moment.locale(language);

    return (
      <div className={styles.activity_section}>
        <div className={styles.activity_section_frame}>
          <h3>{_("recentActivities")}</h3>
          <div className={styles.activity_section_filter}>
            <div
              ref={this.setActivitiesWrapperRef.bind(this)}
              className={
                styles.customed_select +
                " " +
                (activitiesFilterIsVisible ? styles.customed_select_opened : "")
              }
            >
              <div className={styles.customed_select_header}>
                <span>{_(day.label)}</span>
                <div className={styles.actions}>
                  <div>
                    <span
                      className={styles.action}
                      onClick={this.handleDisplayActivitiesFilter}
                    >
                      <TiArrowSortedDown />
                    </span>
                  </div>
                </div>
              </div>
              {activitiesFilterIsVisible && (
                <div className={styles.customed_select_body}>
                  <div className={styles.customed_select_body_options}>
                    {DAYS_CONFIG.map((item, index) => (
                      <div
                        key={index}
                        className={styles.customed_select_body_option}
                        onClick={() => this.handleSelectActivitiesFilter(item)}
                      >
                        {_(item.label)}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {loading ? (
            <CollaboratorSpaceAsideFetching />
          ) : error ? (
            <div className={styles.error_frame}>
              <TiWarningOutline />
              <span>{_("oops")}</span>
            </div>
          ) : (
            <div className={styles.cellules}>
              {displayedActivities && displayedActivities.length === 0 ? (
                <div className={styles.noData}>
                  <div className={styles.cercle}>
                    <HistoryIcon fill={"#B2BCC6"} size={26} />
                  </div>
                  <span>{_("noActivities")}</span>
                </div>
              ) : (
                displayedActivities &&
                displayedActivities.map((activity, index) => (
                  <div className={styles.cellule} key={index}>
                    <div className={styles.cellule_header}>
                      <div className={styles.icone_frame}>
                        <HistoryIcon />
                      </div>
                      <span>
                        {moment(
                          activity.createdAt.date,
                          "YYYY-MM-DD hh:mm:ss"
                        ).fromNow()}
                      </span>
                    </div>
                    {this.renderActivityAction(activity.action)}
                    <div className={styles.line}>
                      <span className={styles.label}>{_("folder")} : </span>
                      <span className={styles.value}>{activity.client}</span>
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  handleClickOutsideActivitiesFilter = event => {
    if (
      this.activitiesWrapperRef &&
      !this.activitiesWrapperRef.contains(event.target)
    ) {
      this.setState({ activitiesFilterIsVisible: false });
    }
  };

  handleDisplayActivitiesFilter = () => {
    this.setState(state => {
      return {
        activitiesFilterIsVisible: !state.activitiesFilterIsVisible
      };
    });
  };

  handleSelectActivitiesFilter = item => {
    let { activities } = this.state;
    const displayedActivities =
      activities && activities.length > 0 && item.daysToSub !== null
        ? activities.filter(
            activity =>
              moment(activity.createdAt.date, "YYYY-MM-DD hh:mm:ss").format(
                "YYYY-MM-DD"
              ) ===
              moment()
                .subtract(item.daysToSub, "days")
                .format("YYYY-MM-DD")
          )
        : activities;

    this.setState({
      day: item,
      displayedActivities,
      activitiesFilterIsVisible: false
    });
  };

  render() {
    return (
      <div className={styles.aside_content}>
        {this.renderUserSection()}
        {this.renderActivitiesSection()}
      </div>
    );
  }
}

export default CollaboratorSpaceAside;



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpaceAside.js